import React, { useState, useEffect } from "react";
import firebase from "firebase";
import { auth, db, storage } from "../service/firebase";
import { ToastContainer, toast } from "react-toastify";

function AddPostRight() {
  const [progress, setProgress] = useState(0);
  const [caption, setCaption] = useState("");
  const [imagePost, setImagePost] = useState(null);

  const [user, setUser] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(function (authUser) {
      if (authUser) {
        // User is signed in.
        setUser(authUser);
      } else {
        // No user is signed in.
        setUser(null);
      }
    });
  }, []);

  const handleChange = (e) => {
    if (e.target.files[0]) {
      setImagePost(e.target.files[0]);
    }
  };

  const uploadPost = (e) => {
    e.preventDefault();
    const storePost = storage
      .ref(`postImages/${imagePost.name}`)
      .put(imagePost);

    storePost.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => {
        console.log(error);
        alert(error.message);
      },
      () => {
        storage
          .ref("postImages")
          .child(imagePost.name)
          .getDownloadURL()
          .then((url) => {
            db.collection("posts")
              .add({
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                caption: caption,
                postImage: url,
                username: auth.currentUser.displayName,
              })
              .then(() => {
                console.log("success");
              })
              .catch((error) => {
                console.log(error.message);
              });
            setProgress(0);
            setCaption("");
            setImagePost(null);
            toast.success("Post Uploaded successfully");
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          });
      }
    );
  };

  return (
    <div>
      <ToastContainer
        position="top-center"
        hideProgressBar
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
        draggable
      />
      <form>
        <h4 className="mb-4">Add Post : </h4>
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
          >{`${progress}%`}</div>
        </div>
        <div className="input-group mt-2">
          <div className="form-group mt-2">
            <input
              type="file"
              disabled={!user}
              onChange={handleChange}
              className="form-control-file"
              id="exampleFormControlFile1"
            />
          </div>
          <small id="passwordHelpBlock" className="form-text text-muted">
            Choose only images
          </small>
        </div>
        <div className="input-group flex-nowrap mt-2">
          <div className="input-group-prepend">
            <span className="input-group-text" id="addon-wrapping">
              Caption
            </span>
          </div>
          <input
            type="text"
            value={caption}
            disabled={!user}
            onChange={(e) => setCaption(e.target.value)}
            className="form-control"
            placeholder="Enter a caption..."
            aria-label="Caption"
            aria-describedby="addon-wrapping"
          />
        </div>
        <button
          type="submit"
          onClick={uploadPost}
          disabled={!auth?.currentUser?.emailVerified}
          className="btn btn-success mt-2"
        >
          {" "}
          Post{" "}
        </button>
        {user ? (
          ""
        ) : (
          <small id="passwordHelpBlock" className="form-text text-muted">
            Login / SignUp to add Post
          </small>
        )}
      </form>
    </div>
  );
}

export default AddPostRight;
